// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HzBxV","slide-down":"Modal_slide-down__tDgXQ"};